import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Lock, MapPin, Info } from "lucide-react";
import api from "../../api";
import temprorary from "../../Imgs/logo_full_transparent.png"; // fallback logo
import { setMetaDescription } from "../../utils/seo";


export default function ProductOffer({
  isLoggedIn,
}) {
  const { hyveProductId } = useParams();
  const [offers, setOffersForSelectedProduct] = useState([]);

  useEffect(() => {
    const latFromStorage = localStorage.getItem("latitude");
    const lngFromStorage = localStorage.getItem("longitude");

    if (!latFromStorage || !lngFromStorage) {
      console.warn("Latitude or Longitude missing → Skipping API call");
      setOffersForSelectedProduct([]);
      return;
    }

    const fetchOffers = async () => {
      try {
        // Hardcoded as per your current backend testing
        const lat = 25.0849855;
        const lng = 55.1998166;

        const url = `/store-offer/api/offers/show/product?hyveProductId=${hyveProductId}&lat=${lat}&lng=${lng}`;

        const response = await api.get(url, {
          headers: {
            Accept: "application/json",
          },
        });

        const offers = response.data?.offers || [];
        setOffersForSelectedProduct(offers);
      } catch (error) {
        console.error("Error fetching offers:", error);
        setOffersForSelectedProduct([]);
      }
    };

    if (hyveProductId) {
      fetchOffers();
    }
  }, [hyveProductId, isLoggedIn]);


  // set SEO meta description based on lowest offer

  useEffect(() => {
  if (!offers || offers.length === 0) return;

  const lowestOffer = [...offers].sort(
    (a, b) => a.offerPrice - b.offerPrice
  )[0];

  if (lowestOffer?.offerPrice) {
    setMetaDescription(
      `Best price AED ${lowestOffer.offerPrice.toLocaleString()} available near you. Compare in-store offers now.`
    );
  }
}, [offers]);


  const daysLeft = (endDate) => {
    if (!endDate) return "No expiry";
    const end = new Date(endDate);
    const today = new Date();
    const diff = Math.ceil((end - today) / (1000 * 60 * 60 * 24));
    if (diff <= 0) return "Expired";
    if (diff === 1) return "Last day";
    return `${diff} days left`;
  };

  return (
    <section className="">
      <h3 className="text-lg font-semibold mb-3">In-store Offers</h3>

      {offers.length === 0 ? (
        <p className="text-xs text-slate-500">
          No offers found for this area yet. Try a different area or “Near me”.
        </p>
      ) : (
        <ul className="grid grid-cols-1 gap-3">
          {offers
            .slice()
            .sort((a, b) => a.offerPrice - b.offerPrice)
            .map((offer, index) => {
              const isLockedLowest = offer.isLowest && !isLoggedIn;
              const showStoreName = isLoggedIn;

              return (
                <li
                  key={index}
                  className={`grid gap-3 grid-cols-[minmax(0,1.7fr)_auto] items-center rounded-2xl border px-3 py-2.5 text-sm bg-white/95 ${
                    offer.isLowest
                      ? "border-emerald-500/80 bg-emerald-50/40"
                      : "border-slate-200/80"
                  }`}
                >
                  {/* LEFT */}
                  <div className="flex items-center gap-3 min-w-0">
                    <img
                      src={offer.store?.logo || temprorary}
                      alt="Store"
                      className="w-9 h-9 rounded-full bg-indigo-50 object-cover"
                    />

                    <div className="space-y-1 min-w-0">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="font-semibold truncate max-w-[14rem]">
                          {showStoreName
                            ? offer.store?.storeName || "Store Name"
                            : "Login to unlock this store"}
                        </span>

                        {offer.isLowest && (
                          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-600 text-white text-[0.7rem]">
                            <Lock className="w-3 h-3" /> Lowest price
                          </span>
                        )}
                      </div>

                      <div className="flex flex-wrap gap-2 text-[0.75rem] text-slate-500">
                        <span className="font-semibold text-slate-900">
                          AED {offer.offerPrice.toLocaleString()}
                        </span>

                        <span>
                          {offer.branches?.[0]?.distanceKm?.toFixed(1)} km away
                        </span>

                        <span>{daysLeft(offer.endDate)}</span>
                      </div>
                    </div>
                  </div>

                  {/* RIGHT */}
                  <div className="flex flex-col items-end gap-1">
                    <button
                      type="button"
                      onClick={() => {
                        const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                          (offer.store?.storeName || "") +
                            " " +
                            (offer.branches?.[0]?.branchName || "")
                        )}`;
                        window.open(url, "_blank");
                      }}
                      className="inline-flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-full border border-slate-300/80 text-[0.75rem] text-slate-700 hover:border-indigo-500 hover:text-indigo-600"
                    >
                      <MapPin className="w-3.5 h-3.5" /> Directions
                    </button>

                    <button
                      type="button"
                      onClick={() => alert("Show offer details popup")}
                      className="inline-flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-full text-[0.75rem] text-indigo-700 hover:bg-indigo-50"
                    >
                      <Info className="w-3.5 h-3.5" /> View details
                    </button>
                  </div>

                  {isLockedLowest && (
                    <p className="col-span-2 flex items-center gap-1.5 text-[0.7rem] text-slate-600 mt-1">
                      <Lock className="w-3.5 h-3.5" /> Login or sign up to see the
                      store name for the lowest price.
                    </p>
                  )}
                </li>
              );
            })}
        </ul>
      )}
    </section>
  );
}
